export default "__VITE_ASSET__CbOp438R__"